import _ from 'lodash';

import {createResourcesUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {TagModel} from '../../../models/api/tagModel';
import {AppAction} from '../../appActions';
import {ResourceMap} from '../../appTypes';
import {DataGroupsActionsEnum} from '../dataGroupsActions';
import {TagsActionsEnum} from './tagsActions';

/*
 * Reducer.
 */

const tagsUpdatedReducer = createResourcesUpdatedReducer('tags', (tag) => tag.id);

export function tagsReducer(state: ResourceMap<TagModel>, action: AppAction): ResourceMap<TagModel> {
  switch (action.type) {
    // Data Group.
    case DataGroupsActionsEnum.DATA_UPDATED:
      return tagsUpdatedReducer(state, action);

    // Single tag deletion.
    case TagsActionsEnum.TAG_DELETED:
      return _(state)
        .omit(action.payload)
        .mapValues((v) => (v && v.parentTagId === action.payload ? {...v, parentTagId: undefined} : v))
        .value();

    default:
      return state;
  }
}
